var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$root.inProfileCartMode)?_c('a',{staticClass:"btn btn-sm btn-primary ml-lg-auto",attrs:{"href":_vm.plans_comparison_url}},[_vm._v("\n    Add more plans\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }